<template>
  <div class="container-page">
    <div
      class="container-page__head--title black--text font-weight-medium"
      :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }"
    >
      <DashboardBreadcrumb :items="breadCrumbItems" />
    </div>
    <div class="container-page__mid-body mt-4">
      <v-card elevation="4" class="px-8 py-6">
        <v-row
          class="loader fill-height py-6"
          align="center"
          justify="center"
          v-if="isContainerFormLoading || retrievingEditExportJob"
        >
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-row>
        <div v-else>
          <div class="container-page__mid-body__header d-sm-flex align-center" :class="{ 'text-center': breakpointXs }">
            <div
              class="container-page__mid-body__header--title fw-600"
              :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }"
            >
              Container
            </div>
            <v-spacer v-if="!breakpointXs"></v-spacer>
            <div class="container-page__mid-body__header__search" :class="{ 'mr-4': !breakpointXs }">
              <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
            </div>
            <div class="container-page__mid-body__header--button" :class="{ 'mt-3': breakpointXs }">
              <v-btn
                width="180"
                color="button-primary"
                large
                class="white--text"
                @click="addNewContainerActionHandler()"
              >
                <v-icon left>fas fa-plus</v-icon>
                <span class="font-weight-bold fs-15">Add New</span>
              </v-btn>
            </div>
          </div>
          <div class="container-page__mid-body__table mt-2">
            <v-data-table
              :headers="tableHeaders"
              class="text-center"
              :items="containers"
              :search="search"
              :items-per-page="5"
            >
              <template v-slot:item.edit="{ item }">
                <v-btn
                  color="lightPrimary"
                  class="info font-weight-bold"
                  dense
                  @click="updateContainerActionHandler(item)"
                  >Edit</v-btn
                >
              </template>
              <template v-slot:item.delete="{ item }">
                <v-btn
                  color="lightPrimary"
                  class=" error font-weight-bold"
                  dense
                  @click="deleteContainerActionHandler(item)"
                  >Delete</v-btn
                >
              </template>
            </v-data-table>
          </div>
          <v-row>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <div class="d-sm-flex justify-start" :class="{ 'text-center': breakpointXs }">
                <v-btn
                  width="140"
                  color="info"
                  large
                  class="white--text"
                  :loading="isContainerFormLoading || savingExportJob"
                  @click="$router.push({ name: 'dashboard.export.freight-insurance' })"
                >
                  <v-icon class="font-weight-bold fs-15 mr-2">fa fa-arrow-circle-left</v-icon>
                  <span class="font-weight-bold fs-15">Previous</span>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
              <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
                <v-btn
                  width="140"
                  color="button-primary"
                  large
                  class="white--text"
                  :loading="isContainerFormLoading || savingExportJob"
                  @click="saveContainers"
                >
                  <span class="font-weight-bold fs-15">Save</span>
                </v-btn>
                <div class="ml-2 mr-2 my-1"></div>
                <v-btn
                  width="140"
                  color="info"
                  large
                  class="white--text"
                  :loading="isContainerFormLoading || savingExportJob"
                  @click="$router.push({ name: 'dashboard.export.shipment' })"
                >
                  <span class="font-weight-bold fs-15">Next</span>
                  <v-icon class="font-weight-bold fs-15 ml-2">fa fa-arrow-circle-right</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </div>
    <AddContainerModal
      max-width="850"
      v-if="showAddNewContainer"
      :newContainer="isNewContainer"
      :srNo="srNo"
      @close-container-modal="closeContainerModalActionHandler"
    />
  </div>
</template>
<script>
import DashboardBreadcrumb from "@/modules/DashboardModule/components/DashboardBreadcrumb";
import AddContainerModal from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/components/AddContainerModal";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "Container",
  components: {
    DashboardBreadcrumb,
    AddContainerModal
  },
  data() {
    return {
      isContainerFormLoading: false,
      showAddNewContainer: false,
      isNewContainer: false,
      srNo: null,
      search: ""
    };
  },
  beforeDestroy() {
    //  this.makeFieldsNull();
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    deleteContainerActionHandler(containerToBeRemoved) {
      this.$store.commit(MT.REMOVE_CONTAINER_FROM_EXPORT_JOB, { srNo: containerToBeRemoved.srNo });
      this.$store.commit(MT.REASSIGN_SRNO_TO_CONTAINER_EXPORT_JOB, containerToBeRemoved.srNo);

      return;
    },
    updateContainerActionHandler(container) {
      this.srNo = container.srNo;
      this.$store.commit(MT.SET_CONTAINER_FROM_EXPORT_JOB, { container: container, srNo: container.srNo });
      this.showAddNewContainer = true;
      return;
    },
    addNewContainerActionHandler() {
      //   this.makeFieldsNull();
      this.isNewContainer = true;
      this.srNo = this.containers.length + 1;
      this.showAddNewContainer = true;
      return;
    },
    saveContainers() {
      this.saveExportJob();
      return;
    },
    saveContainerActionHandler() {
      this.isNewContainer = false;
      this.dialog = false;
      return;
    },
    closeContainerModalActionHandler() {
      this.showAddNewContainer = false;
    }
  },
  computed: {
    containers() {
      return this.$store.getters.exportJob.containers.map((container, index) => ({
        ...container,
        srNo: index + 1
      }));
    },
    tableHeaders() {
      return [
        { text: "Sr No", value: "srNo", align: "center" },
        { text: "Container No", value: "containerNo", align: "center" },
        { text: "Container Size", value: "containerSize", align: "center" },
        { text: "Seal No", value: "exciseSealNo", align: "center" },
        { text: "Seal Date", value: "sealDate", align: "center" },
        { text: "Seal Type", value: "sealTypeIndicator", align: "center" },
        { text: "Container Type", value: "movementDocumentType", align: "center" },
        { text: "Edit", value: "edit", align: "center" },
        { text: "Delete", value: "delete", align: "center" }
      ];
    },

    breadCrumbItems() {
      return [
        {
          title: "Dashboard",
          route: "dashboard.home",
          children: [
            {
              title: "Export",
              route: "dashboard.export",
              children: [
                {
                  title: "Container",
                  route: "dashboard.export.container"
                }
              ]
            }
          ]
        }
      ];
    },
    countries() {
      return this.$store.getters.countries;
    }
  }
};
</script>
<style lang="scss">
.container-page {
  &__mid-body {
    &__table {
      .v-data-table {
        background: transparent !important;
      }
    }
  }
}
</style>
